exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".menu-planner{margin-top:20px}.menu-planner .content{border-left:#eee 1px solid}.menu-planner .content .recipes{margin-top:0}.menu-planner .content .recipes .page-header{margin-top:0}.menu-complete-btn{border-radius:0 0 0 2px !important;width:100%}.menu-complete-btn .glyphicon-ok{margin-left:10px}.menu-edit-btn{border-radius:0 0 2px 0 !important;width:100%}.menu-edit-btn .glyphicon-ok{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./modules/menu/css/menu.scss
// module id = 600
// module chunks = 0